import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { ElementMGroupDto} from '@jobindsats/typescript-fetch-jobindsats';
import { AccordionStatus } from './model/maaling-accordion-status-type';
import { dimensionStyles } from './styles/dimension-styles';

@customElement('maaling-selection-element')
export class MaalingSelectionElement extends JobindsatsElement(LitElement) {
    static styles = [dimensionStyles, css`
        ul {
            column-count: auto;
            column-width: 33vh;
        }
        li {
            page-break-inside: avoid;
            break-inside: avoid;
            display:table;
            margin-bottom: 10px;
        }
    `];

    @state()
    allSubmeasuresSelected = false;

    @property()
    mGroups?: Array<ElementMGroupDto>;

    @state()
    accordionStatus: AccordionStatus[] = [];

    @state()
    selectedSubmeasures: string[] = [];

    connectedCallback() {
        super.connectedCallback();

        if (this.mGroups?.length === 1) {
            this.handleAllSelected();
        }

    }
    constructor() {
        super();
    }

    render() {
        if (this.mGroups && this.mGroups.length) {
        return html`
              <div class="maaling-container">
                <div class="select-all">
                    <a href="#!" role="button" @click=${this.handleAllSelected}>Vælg / Fravælg alle</a>
                </div>
                <ul id="maaling-cboxes">
                    ${this.mGroups?.map(mGroup => {
                        return html`
                            <li><input id=${mGroup.mgroupID ?? null} type="checkbox" .checked=${this.allSubmeasuresSelected} 
                                    @click=${() => {
                                        if (mGroup.mgroupID) {
                                            const mGroupId = mGroup.mgroupID;
                                            const selectionIndex =
                                                this.selectedSubmeasures.findIndex(subMeasure => subMeasure === mGroupId);
                                            if (selectionIndex > -1) {
                                                this.selectedSubmeasures.splice(selectionIndex, 1);
                                            } else if (mGroupId) {
                                                this.selectedSubmeasures.push(mGroupId);
                                            }
                                        }
                                        this.handleSubmeasureSelection();}}>
                                <label for="${mGroup.mgroupID}">${mGroup.displayName}</label>
                            </li>`;})}
                        </ul>
                    </div>`;
        } else {
            return html`
                <div class="maaling-container">
                    Ingen submålinger tilknyttet måling
                 </div>
            `;
        }}

    handleSubmeasureSelection() {
        const submeasureSelectedEvent = new CustomEvent('submeasure-selected', {
            detail: {
                measures: this.selectedSubmeasures
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(submeasureSelectedEvent);
    }

    handleAllSelected() {
        if (this.selectedSubmeasures.length > 0) {
            this.selectedSubmeasures = [];
            this.allSubmeasuresSelected = false;
            const divCheckboxes = this.shadowRoot?.getElementById('maaling-cboxes')?.children;
            if (divCheckboxes?.length) {
                for (let i = 0; i < divCheckboxes.length; i++) {
                    const currentCb = divCheckboxes[i].children[0] as HTMLInputElement;
                    currentCb.checked = false;
                }
            }
        } else {
            this.selectedSubmeasures = [];
            this.mGroups?.map(mGroup => {
                if (mGroup.mgroupID) {
                    this.selectedSubmeasures.push(mGroup.mgroupID);
                }
            });
            this.allSubmeasuresSelected = true;
        }
        this.handleSubmeasureSelection();
    }
}

